import React, { useState, useEffect } from "react";
import styled from "styled-components";
import firebase from "firebase";

import {
  ClassroomContainer,
  ClassroomBody,
  ClassroomNav,
  FormButton,
  useUserId
} from "./Classroom";
import { data } from "./CardFlipData";

const CardGrid = styled.div`
  width: 100%;
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(6, 1fr);
  padding: 3rem;
  justify-items: center;
  font-family: var(--body);
  @media (max-width: 768px) {
    flex-direction: column;
    grid-template-columns: repeat(4, 1fr);
  }
`;

const cardSize = `
width: 8rem;
  height: 8rem;
`;

const FlipContainer = styled.div`
  perspective: 1000px;
  display: inline-block;
  text-align: center;
  ${cardSize}
`;

const Flipper = styled.div`
  transform: rotateY(${({ flipped }) => (flipped ? 180 : 0)}deg);
  transition: 0.6s;
  transform-style: preserve-3d;
  position: relative;
`;

const Front = styled.div`
  ${cardSize}
  backface-visibility: hidden;
  background-color: var(
    ${({ nonPrefered }) => (nonPrefered ? "--blue" : "--gold")}
  );
  color: var(${({ nonPrefered }) => (nonPrefered ? "--gold" : "--blue")});
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
  /* for firefox 31 */
  transform: rotateY(0deg);
`;

const Back = styled.div`
  ${cardSize}
  backface-visibility: hidden;
  background-color: var(
    ${({ nonPrefered }) => (nonPrefered ? "--blue" : "--gold")}
  );
  color: var(${({ nonPrefered }) => (nonPrefered ? "--gold" : "--blue")});
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: rotateY(180deg);
`;

const Title = styled.h2`
  color: var(--white);
  font-family: var(--title);
  font-size: 2rem;
`;

function Card({ front, back, preferred, onFlip, flipped }) {
  return (
    <FlipContainer onClick={onFlip}>
      <Flipper flipped={flipped}>
        <Front nonPrefered={preferred === 1}>{front}</Front>
        <Back nonPrefered={preferred === 0}>{back}</Back>
      </Flipper>
    </FlipContainer>
  );
}

export function CardFlip() {
  const id = useUserId();
  const [flipped, setFlipped] = useState({});
  const [preferred, setPreferred] = useState(null);

  const compromises =
    preferred &&
    Object.entries(preferred)
      .map(([index, preferred]) => {
        return !!preferred !== !!flipped[index];
      })
      .filter(e => e).length;

  useEffect(() => {
    firebase
      .database()
      .ref(`people/${id}/cardgame`)
      .set({ flipped, preferred });
  }, [flipped, preferred, id]);

  function doSetPreferred() {
    setPreferred(
      Object.fromEntries(
        data.map((_, i) => {
          return [i, flipped[i] ? 1 : 0];
        })
      )
    );
  }

  return (
    <ClassroomContainer>
      <ClassroomNav backToClassroom={true}>
        {preferred === null ? (
          <FormButton onClick={doSetPreferred}>Save Selection</FormButton>
        ) : (
          <Title>{`You've flipped ${compromises} card${
            compromises === 1 ? "" : "s"
          }`}</Title>
        )}
      </ClassroomNav>
      <ClassroomBody>
        <CardGrid>
          {data.map(([front, back], index) => {
            return (
              <Card
                key={front}
                front={front}
                back={back}
                onFlip={() => setFlipped(f => ({ ...f, [index]: !f[index] }))}
                flipped={flipped[index]}
                preferred={preferred === null ? null : preferred[index]}
              />
            );
          })}
        </CardGrid>
      </ClassroomBody>
    </ClassroomContainer>
  );
}
